import { Button } from 'antd'
import styles from './OkButton.module.less'
export default function OkButton(props) {
  return (
    <Button
      size="large"
      loading={props.loading}
      htmlType="submit"
      className={styles.okButton}
      style={{ height: 48 }}
      block
      type="primary"
      onClick={props.onClick}
    >
      {props.children || '登录'}
    </Button>
  )
}
